import { ref, toRaw } from 'vue'
import { apiService } from '~/services/api'
import type { IMember } from '~~/types'

const memberData = ref<IMember | null>(null)

export function useMember () {
    async function fetchMember (): Promise<boolean> {
        const { data, error } = await apiService.auth.info()

        if (error || !data) {
            console.error(error)
            memberData.value = null
            // memberDataRaw.value = null
            return false
        }

        memberData.value = data.data
        return true
    }

    function getMemberDataRaw () {
        return toRaw(memberData.value)
    }

    return {
        member: memberData,
        fetchMember,
        getMemberDataRaw,
    }
}
